import {
  DYNAMIC_CONTENT,
  LOADING_CONTENT,
  CLEAN_STORE,
  SHOW_BANNER,
  DYNAMIC_CONTENT_TYP,
} from "../types/dynamicContent";

export const setDynamicContent = (value) => ({
  type: DYNAMIC_CONTENT,
  payload: value,
});

export const setLoadingContent = (value) => ({
  type: LOADING_CONTENT,
  payload: value,
});

export const cleanStore = () => ({
  type: CLEAN_STORE,
});

export const setShowBanner = (value) => ({
  type: SHOW_BANNER,
  payload: value,
});

export const setDynamicContentTYP = (value) => ({
  type: DYNAMIC_CONTENT_TYP,
  payload: value,
});
